export default {"src":"/_next/static/media/cardAndLetter_24.8620882e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};